// extracted by mini-css-extract-plugin
export default {"v-fog":"#F7F7F7","loader":"animation__loader___IxT_","sweep":"animation__sweep__s6UJA","delayAppear":"animation__delayAppear__W466D"};